import { z } from "zod";
export const IntegrationAuthType = z.union([
    z.literal("OAuth2"),
    z.literal("PAT"),
]);
export const ExternalServiceType = z.union([
    z.literal("figma"),
    z.literal("github"),
    z.literal("azure"),
    z.literal("gitlab"),
    z.literal("bitbucket"),
]);
export const IntegrationUserInfo = z.object({
    id: z.string(),
    handle: z.string().optional(),
    avatarUrl: z.string().optional(),
    email: z.string().optional(),
    authType: IntegrationAuthType.optional(),
    customUrl: z.string().optional(),
});
export const UserLinkedIntegrations = z.object({
    figma: IntegrationUserInfo.optional(),
    github: IntegrationUserInfo.array().optional(),
    azure: IntegrationUserInfo.array().optional(),
    gitlab: IntegrationUserInfo.array().optional(),
    bitbucket: IntegrationUserInfo.array().optional(),
});
